<template>
  <div>
    <div class="panel-heading order-heading-with-stats">
      <h4 class="panel-title">{{ $t('orders.customerDeliveredOrdersTitle') }}</h4>

      <div class="order-heading-right">
        <div class="order-toolbar-buttons">
          <a class="order-toolbar-btn order-toolbar-btn--icon-only" :title="$t('orders.filtersToggleLabel')" @click="toggleFiltersVisible">
            <i class="material-icons">{{ showFilters ? 'expand_less' : 'expand_more' }}</i>
          </a>
          <a class="order-toolbar-btn" :class="{ 'order-toolbar-btn--icon-only': !showButtonLabels }" @click="reloadTable">
            <i class="material-icons">cached</i>
            <span v-if="showButtonLabels">{{ $t('datatable.reloadShortLabel') }}</span>
          </a>
          <a v-if="$_has_perm('add_second_shipping_invoice')" class="order-toolbar-btn" :class="{ 'order-toolbar-btn--icon-only': !showButtonLabels }" @click="openSecondOrderInvoiceModal()">
            <i class="fa fa-file-text-o"></i>
            <span v-if="showButtonLabels">{{ $t('datatable.secondInvoiceShortLabel') }}</span>
          </a>
          <a class="order-toolbar-display-toggle" @click="$_toggle_toolbar_button_display()">
            <i class="material-icons">{{ showButtonLabels ? 'label_off' : 'label' }}</i>
          </a>
        </div>

        <div class="order-stats-row order-stats-row--compact">
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--blue"><i class="material-icons">list_alt</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('reports.totalOrders') }}</span>
              <span class="order-stat-value">{{ summaryTotalOrders }}</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--green"><i class="material-icons">attach_money</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('printLogs.totalAmountLabel') }}</span>
              <span class="order-stat-value">$ {{ summaryTotalAmount.toFixed(2) }}</span>
              <span v-if="qrCodeValues.length > 0" class="order-stat-note">({{ qrCodeValues.length }} selected)</span>
              <span v-else-if="!filterMade" class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--purple"><i class="material-icons">today</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('adminDashboard.ordersTodayLabel') }}</span>
              <span class="order-stat-value">{{ ordersTodayCount }}</span>
              <span class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
          <div class="order-stat-card">
            <div class="order-stat-icon order-stat-icon--orange"><i class="material-icons">payment</i></div>
            <div class="order-stat-text">
              <span class="order-stat-label">{{ $t('adminDashboard.pendingPaymentsLabel') }}</span>
              <span class="order-stat-value">{{ pendingPaymentsCount }}</span>
              <span class="order-stat-note">({{ $t('orders.currentPageScopeNote') }})</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          ref="preDatatable"
          :permissions="{
            add_second_shipping_invoice: 'add_second_shipping_invoice'
          }"
          :openSecondOrderInvoiceModal="openSecondOrderInvoiceModal"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :hideReloadButton="true"
          :collapsibleFilters="true"
          :filtersVisible="showFilters"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :searchMe="searchMe"
          :enableCustomerSearchSuggestions="true"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :resetGetResults2="resetGetResults2"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :defaultHideCol="defaultHideCol"
          :storageKey="'cols_userDeliveredOrder_v3'"
          :resultsVersion="resultsVersion"
          :filterMade="filterMade"
          :filterTable="filterTable"
          :totalResult="totalResult"
          :warehouseFilterItems="warehouses"
          :warehouseFilterChange="handleWarehouseFilter"
          @branch-edit="branchEdit"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>
          <div class="table-responsive oc-table-shell">
          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            :checkAll="checkAll"
            :unCheckAll="unCheckAll"
          >
            <tbody>
              <tr
                v-for="(r, index) in apiResults"
                :key="r.order_id"
                :style="qrCodeValues.find(x => x == r.order_id) ? 'background-color: #FFF9C4' : '' "
              >
                <td>
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID, r.total_amount, r.warehouse_id_fk, r.transportation_type, r.is_ship_only]"
                    v-model="qrCodeValues"
                  />
                </td>
                <td class="oc-cell hover-container">
                  <div class="oc-order-number">
                    <i v-if="r.qrcode" class="fa fa-qrcode" style="color:#388E3C" aria-hidden="true"></i> #{{ r.theOrderID }}
                  </div>
                  <div class="oc-order-sub" v-if="r.qrcode"><i class="fa fa-qrcode" aria-hidden="true"></i> {{ r.qrcode }}</div>
                  <div class="oc-order-sub" v-if="r.track_number">{{ $t('columns.trackNumber') }}: {{ r.track_number }}</div>
                  <div class="oc-order-sub" v-if="r.last_order_invoice">{{ $t('columns.invoiceNumber') }}: {{ r.last_order_invoice }}</div>
                  <div class="oc-order-sub"><view-order-users :orderData="r" /></div>
                </td>
                <td class="oc-cell ws-nowrap">
                  <customer-device-icon :orderSource="r.order_source" />
                  <img v-if="r.profile_image" :src="r.profile_image.startsWith('http') ? r.profile_image : `${$_image_path()}${r.profile_image}`" class="customer-profile-image" />
                  <span class="customer-name-stack">
                    <span v-if="r.full_name && r.full_name.trim().split(/\s+/).length > 3" style="word-break: break-word; white-space: pre-line;">
                      {{ r.full_name.replace(/((?:\S+\s+){3})/g, '$1\n') }}
                    </span>
                    <span v-else>{{ r.full_name }}</span>
                    <span v-if="r.customer_id_fk" class="oc-customer-id">ID: {{ r.customer_id_fk }}</span>
                    <span v-if="r.phone_number" class="customer-phone-line">{{ r.phone_number }}</span>
                    <span v-if="r.phone_number_2" class="customer-phone-line">{{ r.phone_number_2 }}</span>
                  </span>
                  <open-whatsapp-and-viber :phoneNumber="r.phone_number" />
                </td>
                <td class="oc-cell">
                  <div class="oc-item-name">{{ r.product_name ? r.product_name.substr(0, 35) + (r.product_name.length > 35 ? '...' : '') : '—' }}</div>
                  <div class="oc-item-sub" v-if="r.brand">{{ $t('columns.brand') }}: <strong>{{ r.brand }}</strong></div>
                  <a v-if="r.product_url" :href="r.product_url" target="_blank" rel="noopener noreferrer" class="oc-item-link">
                    <i class="material-icons">link</i> {{ $t('columns.url') }}
                  </a>
                </td>
                <td class="oc-cell oc-product-cell">
                  <img
                    v-if="r.image"
                    :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                    class="oc-thumb"
                    @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"
                  />
                  <span v-else class="oc-thumb-placeholder">—</span>
                </td>
                <td class="oc-cell">
                  <span class="oc-status-chip" style="background:#89D7B7; color:#1A5940;">{{ $_status_label(r.status) }}</span>
                  <span
                    v-if="r.is_ship_only == 1"
                    class="oc-status-chip rtl-ml-2"
                    style="background-color:#FCE4EC; color:#C2185B;"
                  >{{ $t('columns.shipOnly') }}</span>
                  <div class="oc-location-line" v-if="r.country">
                    <i class="material-icons oc-location-icon">place</i>{{ r.country }}<span v-if="r.transportation_type_obj"> · {{ r.transportation_type_obj.name.replace('Transportation', '') }}</span>
                  </div>
                  <div class="oc-item-sub" v-if="r.purchase_note">{{ $t('columns.purchaseNote') }}: {{ r.purchase_note }}</div>
                </td>
                <td class="combined-cell-td oc-cell">
                  <div class="combined-cell">
                    <div><span class="combined-cell-label">{{ $t('columns.price') }}:</span> {{ r.item_price }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.shipping') }}:</span> {{ r.internal_shipping_handling }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.total') }}:</span> {{ r.total_amount }}</div>
                    <div class="combined-cell-divider"></div>
                    <div><span class="combined-cell-label">{{ $t('columns.qty') }}:</span> {{ r.quantity }}</div>
                    <div><span class="combined-cell-label">{{ $t('columns.size') }}:</span> {{ r.size }}</div>
                  </div>
                </td>
                <td class="oc-cell hover-container" style="min-width: 150px">
                  <view-order-dates :orderData="r" stack-time />
                  <span
                    v-if="r.payment_status"
                    class="oc-payment-chip"
                    :style="{ background: paymentStatusColor(r.payment_status).bg, color: paymentStatusColor(r.payment_status).color }"
                  >{{ paymentStatusLabel(r.payment_status) }}</span>
                </td>
                <td class="oc-cell oc-actions-cell">
                  <div class="oc-actions-grid">
                    <a
                      v-if="$_has_perm('view_order_detail')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.viewDetails')"
                      @click="initDetail('modal_showApp', r.order_id)"
                    >
                      <i class="material-icons" style="color:#01579B">aspect_ratio</i>
                    </a>
                    <a
                      v-if="$_has_perm('return_delivered_order_to_purchased_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.returnToPurchaseTooltip')"
                      @click="returnToPurchase(r.order_id)"
                    >
                      <i class="material-icons" style="color:#eb8545">settings_backup_restore</i>
                    </a>
                    <a
                      v-if="$_has_perm('refund_approved_order')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.refundThisOrderTooltip')"
                      @click="openRefundOrderModal(r.order_id, r.total_amount)"
                    >
                      <i class="material-icons" style="color:#c62828">block</i>
                    </a>
                    <a
                      v-if="$_has_perm('add_partial_refund')"
                      class="oc-action-btn"
                      :tooltip="$t('orders.partialRefundTooltip')"
                      @click="openPartialRefundOrderModal(r.order_id, r.total_amount)"
                    >
                      <i class="fa fa-registered" style="color:#ff5722"></i>
                    </a>
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    {{ $t('common.noResultsFound') }}
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>
          </div>

          <div v-if="isMobile">
            <div
              v-for="(r, index) in apiResults"
              :key="r.order_id"
              class="moc-container"
            >
              <div class="moc-card">
                <div class="moc-header" :style="qrCodeValues.find(x => x[0] == r.order_id) ? 'border: 2px solid #FBC02D;' : ''">
                  <input
                    :id="'cb' + index"
                    type="checkbox"
                    :value="[r.order_id, r.full_name, r.phone_number, r.user_id, r.theOrderID, r.total_amount, r.warehouse_id_fk, r.transportation_type, r.is_ship_only]"
                    v-model="qrCodeValues"
                    class="rtl-mr-8"
                  />
                  <span class="moc-item-code">{{ r.theOrderID }}<span v-if="r.track_number" style="font-size:10px; color:#555; font-weight:400;"> · {{ r.track_number }}</span></span>
                  <span class="moc-status-badge" :style="{ background: '#89D7B7', color: '#1A5940' }">{{ $_status_label(r.status) }}</span>
                </div>
                <div class="moc-body">
                  <!-- User -->
                  <div class="moc-row">
                    <span class="moc-label">{{ $t('common.user') }}</span>
                    <span class="moc-value"><view-order-users :orderData="r" /></span>
                  </div>
                  <!-- QR -->
                  <div class="moc-row" v-if="r.qrcode">
                    <span class="moc-label">{{ $t('columns.qr') }}</span>
                    <span class="moc-value"><i class="fa fa-qrcode" aria-hidden="true"></i> {{ r.qrcode }}</span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <div>
                      <span class="moc-label">{{ $t('columns.invoiceNo') }}</span>
                      <span class="moc-value">{{ r.last_order_invoice || '—' }}</span>
                    </div>
                    <div>
                      <span class="moc-label">{{ $t('columns.customerId') }}</span>
                      <span class="moc-value">{{ r.customer_id_fk || '—' }}</span>
                    </div>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.phone') }}</span>
                    <span class="moc-value">{{ r.phone_number || '—' }}</span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.customer') }}</span>
                    <span class="moc-value">{{ r.full_name }}</span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.item') }}</span>
                    <span class="moc-value">{{ r.product_name ? r.product_name.substr(0, 35) + (r.product_name.length > 35 ? '...' : '') : '—' }}</span>
                  </div>
                  <div class="moc-row moc-row--2col" v-if="r.brand">
                    <span class="moc-label">{{ $t('columns.brand') }}</span>
                    <span class="moc-value">{{ r.brand }}</span>
                  </div>
                  <div class="moc-row moc-row--2col" v-if="r.product_url">
                    <span class="moc-label">{{ $t('columns.url') }}</span>
                    <span class="moc-value">
                      <a :href="r.product_url" target="_blank" rel="noopener noreferrer" style="color:#01579B;">
                        <i class="material-icons" style="font-size:20px; vertical-align:middle;">link</i>
                      </a>
                    </span>
                  </div>
                  <div class="moc-row" v-if="r.image">
                    <span class="moc-label">{{ $t('columns.image') }}</span>
                    <span class="moc-value">
                      <img
                        :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                        style="width:80px; height:80px; object-fit:cover; border-radius:4px; cursor:pointer;"
                        @click="lightboxImage = r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`; lightboxOpen = true"
                      />
                    </span>
                  </div>
                  <div class="moc-row">
                    <span class="moc-label">{{ $t('columns.dateTime') }}</span>
                    <span class="moc-value"><view-order-dates :orderData="r" /></span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <div>
                      <span class="moc-label">{{ $t('columns.warehouse') }}</span>
                      <span class="moc-value">{{ r.country || '—' }}</span>
                    </div>
                    <div>
                      <span class="moc-label">{{ $t('columns.type') }}</span>
                      <span class="moc-value">{{ r.transportation_type_obj ? r.transportation_type_obj.name.replace('Transportation', '') : '—' }}</span>
                    </div>
                  </div>
                  <div class="moc-row moc-row--3col">
                    <div>
                      <span class="moc-label">{{ $t('columns.price') }}</span>
                      <span class="moc-value">{{ r.item_price ? '$' + r.item_price : '—' }}</span>
                    </div>
                    <div>
                      <span class="moc-label">{{ $t('columns.shipping') }}</span>
                      <span class="moc-value">{{ r.internal_shipping_handling ? '$' + r.internal_shipping_handling : '—' }}</span>
                    </div>
                    <div>
                      <span class="moc-label">{{ $t('columns.total') }}</span>
                      <span class="moc-value">{{ r.total_amount ? '$' + r.total_amount : '—' }}</span>
                    </div>
                  </div>
                  <div class="moc-row moc-row--2col" v-if="r.size">
                    <span class="moc-label">{{ $t('columns.size') }}</span>
                    <span class="moc-value">{{ r.size }}</span>
                  </div>
                  <div class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.shipOnly') }}</span>
                    <span class="moc-value">{{ r.is_ship_only == 1 ? $t('common.yes') : $t('common.no') }}</span>
                  </div>
                  <div v-if="r.purchase_note" class="moc-row moc-row--2col">
                    <span class="moc-label">{{ $t('columns.purchaseNote') }}</span>
                    <span class="moc-value">{{ r.purchase_note }}</span>
                  </div>
                  <div class="moc-row moc-row--2col" v-if="r.payment_status">
                    <span class="moc-label">{{ $t('columns.payment') }}</span>
                    <span class="moc-value">
                      <span :style="{ background: paymentStatusColor(r.payment_status).bg, color: paymentStatusColor(r.payment_status).color, padding: '2px 8px', borderRadius: '12px', fontSize: '12px' }">{{ paymentStatusLabel(r.payment_status) }}</span>
                    </span>
                  </div>
                </div>
                <div class="moc-actions">
                  <a v-if="$_has_perm('view_order_detail')" style="color:#01579B" :tooltip="$t('orders.viewDetails')" @click="initDetail('modal_showApp', r.order_id)">
                    <i class="material-icons">aspect_ratio</i>
                  </a>
                  <a v-if="$_has_perm('return_delivered_order_to_purchased_order')" style="color:#eb8545" :tooltip="$t('orders.returnToPurchaseTooltip')" @click="returnToPurchase(r.order_id)">
                    <i class="material-icons">settings_backup_restore</i>
                  </a>
                  <a v-if="$_has_perm('refund_approved_order')" style="color:#C62828" :tooltip="$t('orders.refundThisOrderTooltip')" @click="openRefundOrderModal(r.order_id, r.total_amount)">
                    <i class="material-icons">block</i>
                  </a>
                  <a v-if="$_has_perm('add_partial_refund')" style="color:#FF5722" :tooltip="$t('orders.partialRefundTooltip')" @click="openPartialRefundOrderModal(r.order_id, r.total_amount)">
                    <i class="fa fa-registered" style="font-size:1.6em;"></i>
                  </a>
                </div>
              </div>
            </div>
            <v-alert type="error" :value="alertValue"> {{ $t('common.noResultsFound') }} </v-alert>
          </div>

          <add-order-invoice
            :formData="generateInvoiceData"
            :orderInvoiceModal="orderInvoiceModal"
            @close="orderInvoiceModal = false"
            @invoice-created="getResults()"
            :is_second_invoice="true"
          />

          <v-dialog v-model="lightboxOpen" max-width="600px">
            <v-card>
              <v-card-actions><v-spacer></v-spacer><v-btn icon @click="lightboxOpen=false"><v-icon>close</v-icon></v-btn></v-card-actions>
              <v-card-text style="text-align:center; padding-top:0">
                <img :src="lightboxImage" style="max-width:100%;max-height:80vh;" />
              </v-card-text>
            </v-card>
          </v-dialog>

          <view-order-details
            :detialData="detialData"
            :closeModal="closeModal"
            @open-refund-modal="handleRefundModal"
            @open-partial-refund-modal="handlePartialRefundModal"
          ></view-order-details>

          <refunding-order
            :refundOrderModal="refundOrderModal"
            :refundOrder="refundOrder"
            :refundData="refundData"
            :theOrderTotalAmount="theOrderTotalAmount"
            :checkAlert="checkAlert"
            :closeRefundOrderModal="closeRefundOrderModal"
            :loading="loading"
            :reasons="reasons"
          ></refunding-order>

          <partial-refunding-order
            :partialRefundOrderModal="partialRefundOrderModal"
            :partialRefundOrder="partialRefundOrder"
            :partialRefundData="partialRefundData"
            :theOrderTotalAmount="theOrderTotalAmount"
            :checkAlert="checkAlert"
            :closePartialRefundOrderModal="closePartialRefundOrderModal"
            :loading="loading"
          ></partial-refunding-order>

          <div class="row">
            <div class="col-xs-12 text-center oc-pagination">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from './Pagination.vue'
import preDatatableComponent from './preDatatableComponent.vue'
import DatatableVue from './Datatable.vue'
import viewOrderDetails from './viewOrderDetails.vue'
import refundingOrder from './refundingOrder.vue'
import partialRefundingOrder from './partialRefundingOrder.vue'
import axios from 'axios'
import swal from 'sweetalert'
import AddOrderInvoice from '../components/orderInvoice/AddOrderInvoice.vue'
import statusHelpers from '../mixins/statusHelpers'
import toolbarButtonDisplay from '../mixins/toolbarButtonDisplay'

export default {
  mixins: [statusHelpers, toolbarButtonDisplay],
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-order-details': viewOrderDetails,
    'refunding-order': refundingOrder,
    partialRefundingOrder,
    AddOrderInvoice
  },
  mounted() {
    this.$_fetch_statuses()
    this.getWarehouses()
    this.getReasons()
    this.perPageFix()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    // Grouped columns (redesign, mirrors allOrder.vue's pattern) -- was a flat ~25-column
    // list; each grouped cell stacks several related fields (QR / track # / invoice # /
    // delivered-by user fold into Order Info; ship-only & purchase note into Status &
    // Location; payment chip into Date & Payment). Per-column hide now only makes sense
    // at the group level, so defaultHideCol is emptied and storageKey bumped so stale
    // hidden-column selections don't misapply to new positions.
    let columns = [
      { label: '', name: '', text: this.$t('columns.checkBoxColumn'), value: '1' },
      { label: this.$t('columns.orderInfo'), text: this.$t('columns.orderInfo'), value: '2', sortable: true, searchable: true, name: 'theOrderID' },
      { label: this.$t('columns.customer'), text: this.$t('columns.customer'), value: '3', sortable: true, searchable: true, name: 'full_name' },
      { label: this.$t('columns.itemDetails'), text: this.$t('columns.itemDetails'), value: '4', sortable: true, searchable: true, name: 'product_name' },
      { label: this.$t('columns.product'), text: this.$t('columns.product'), value: '5', sortable: false, searchable: false, name: 'image' },
      { label: this.$t('columns.statusLocation'), text: this.$t('columns.statusLocation'), value: '6', sortable: true, searchable: true, name: 'status' },
      { label: this.$t('columns.pricing'), text: this.$t('columns.pricing'), value: '7', sortable: false, searchable: false, name: 'price_all' },
      { label: this.$t('columns.datePayment'), text: this.$t('columns.datePayment'), value: '8', sortable: true, searchable: false, name: 'updated_at' },
      { label: this.$t('columns.actions'), text: this.$t('columns.actions'), value: '9', sortable: false, searchable: false, name: 'actions' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      qrCodeValues: [],
      generateInvoiceData: {},
      orderInvoiceModal: false,
      // Hidden by default (per-page preference, same localStorage convention as allOrder.vue).
      showFilters: localStorage.getItem('filtersVisible_userDeliveredOrder') === 'true',
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/user_delivery_order',
      orderDetailUrl: 'api/show_order_detail',
      refundOrderUrl: 'api/refunding_order',
      returnToPurchaseUrl: 'api/orders/',
      refundOrderModal: false,
      partialRefundOrderModal: false,
      refundData: { send_sms: false },
      partialRefundData: {},
      theOrderTotalAmount: '',
      the_order_id: '',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      queryParameter: true,
      filterMade: false,
      totalResult: 0,
      resultsVersion: 0,
      detialData: {
        the_tl_price: '',
        order_id: '',
        full_name: '',
        email: '',
        phone_number: '',
        c_o_d: '',
        product_url: '',
        product_name: '',
        description: '',
        coupon_percentage: '',
        item_type: '',
        size: '',
        type: '',
        status: '',
        color: '',
        quantity: '',
        quantity_charge: '',
        coupon: '',
        qrcode: '',
        barcode: '',
        delivery_type: '',
        item_weight: '',
        item_price: '',
        tax: '',
        internal_shipping_handling: '',
        kreenex_fee: '',
        delivery_price: '',
        insurance: '',
        total_amount: '',
        from_date: '',
        to_date: '',
        confirm_date: '',
        theOrderID: '',
        refund_reason: '',
        bank_name: '',
        country: '',
        order_date: '',
        track_number: '',
        discount: '',
        note: ''
      },
      prevSearchQuery: '',
      warehouses: [],
      reasons: [],
      lightboxImage: null,
      lightboxOpen: false,
      apiResults: [],
      detailResults: [],
      // Grouped cells can't be hidden field-by-field any more -- same tradeoff allOrder.vue made.
      defaultHideCol: [],
      columns: columns,
      sortKey: 'updated_at',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'updated_at',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: '',
        warehouse_id_fk: '',
        branches_id: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  computed: {
    summaryTotalOrders() {
      if (this.qrCodeValues.length > 0) return this.qrCodeValues.length
      return this.filterMade
        ? this.apiResults.length
        : (this.pagination.total || this.apiResults.length)
    },
    summaryTotalAmount() {
      return this.apiResults.reduce((sum, r) => sum + (Number(r.total_amount) || 0), 0)
    },
    // Best-effort only: counts within the currently loaded page of apiResults, not a true
    // system-wide count -- hence the "(current page)" note shown alongside it in the stat card.
    ordersTodayCount() {
      const today = new Date().toISOString().split('T')[0]
      return this.apiResults.filter(r => {
        const d = r.deliver_date || r.updated_at || r.order_date || r.created_at
        return d && d.substr(0, 10) === today
      }).length
    },
    // Same current-page-only caveat as ordersTodayCount above.
    pendingPaymentsCount() {
      return this.apiResults.filter(r => r.payment_status && r.payment_status !== 'paid').length
    }
  },

  methods: {
    toggleFiltersVisible() {
      this.showFilters = !this.showFilters
      localStorage.setItem('filtersVisible_userDeliveredOrder', this.showFilters ? 'true' : 'false')
    },

    // Replicates preDatatableComponent.vue's own built-in Reload button (now relocated
    // into the panel-heading here) -- reaches into the child's own filter-chip/date-range
    // reset state via $refs since that state lives inside the shared component, not here.
    reloadTable() {
      this.resetGetResults()
      const preDatatable = this.$refs.preDatatable
      if (preDatatable) {
        preDatatable.filterApplied = false
        preDatatable.resetDatePickerDefaults()
        preDatatable.ware = 'Select'
      }
    },

    paymentStatusColor(status) {
      const map = {
        not_paid: { bg: '#F63049', color: '#FFFFFF' },
        partial_paid: { bg: '#FFC85C', color: '#6B4C00' },
        paid: { bg: '#89D7B7', color: '#1A5940' },
        cancel: { bg: '#FB8C00', color: '#FFFFFF' }
      }
      return map[status] || { bg: '#F5F5F5', color: '#616161' }
    },

    paymentStatusLabel(status) {
      if (!status) return ''
      return status.replace(/_/g, ' ')
    },

    checkAll() {
      this.qrCodeValues = this.apiResults.map(r => [
        r.order_id,
        r.full_name,
        r.phone_number,
        r.user_id,
        r.theOrderID,
        r.total_amount,
        r.warehouse_id_fk,
        r.transportation_type,
        r.is_ship_only
      ])
    },

    unCheckAll() {
      this.qrCodeValues = []
    },

    branchEdit(branches) {
      this.tableData.branches_id = branches.toString()
      this.getResults()
    },

    // Scoped to #datatable (this page's own <datatable> table) and deterministic set/unset —
    // the old unscoped $('td:nth-child(N)') selector matched EVERY table on the page, including
    // the Generate/View Invoice modal's items-table (also 7 columns), silently hiding its Total
    // cell whenever this page's own column visibility got applied. See orderInvoices.vue's
    // showHideColumn for the same fix.
    showHideColumn(prevColVal, currentColVal) {
      const hidden = {}
      currentColVal.forEach((v) => { hidden[v] = true })

      for (let i = 1; i <= this.columns.length; i++) {
        const selector = '#datatable td:nth-child(' + i + '),#datatable th:nth-child(' + i + ')'
        if (hidden[i]) {
          $(selector).hide()
        } else {
          $(selector).show()
        }
      }
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      // A selection made before a filter/search/reload must not silently carry over into
      // the new result set — otherwise a stale row (no longer even visible) stays selected
      // and gets included in the next bulk action, affecting rows the user never intended
      // to touch in the current (filtered) view.
      this.qrCodeValues = []

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          const isFlatArray = Array.isArray(data.data)
          if (isFlatArray) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }
          this.resultsVersion++

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (isFlatArray) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          if (theDatatable) { theDatatable.classList.remove('slide-table-out') }
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(errors => { console.error(errors) })
    },

    openSecondOrderInvoiceModal() {
      if (this.qrCodeValues.length < 1) {
        swal({
          text: this.$t('orders.pleaseSelectOrderOrCustomer'),
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      let customerIds = []
      let ordersArr = []
      this.qrCodeValues.forEach((x, i) => {
        let obj = {
          order_id: null,
          customer_name: null,
          phone: null,
          customer_id: null,
          the_order_id: null,
          total_amount: null,
          warehouse_id: null,
          transportation_type: null,
          is_ship_only: null,
        }
        x.forEach((y, j) => {
          if (j === 0) {
            obj.order_id = y
          } else if (j === 1) {
            obj.customer_name = y
          } else if (j === 2) {
            obj.phone = y
          } else if (j === 3) {
            customerIds.push(y)
            obj.customer_id = y
          } else if (j === 4) {
            obj.the_order_id = y
          } else if (j === 5) {
            obj.total_amount = y
          } else if (j === 6) {
            obj.warehouse_id = y
          } else if (j === 7) {
            obj.transportation_type = y
          } else if (j === 8) {
            obj.is_ship_only = y
          }
        })
        ordersArr.push(obj)
      })

      if (this.checkDiff(customerIds)) {
        swal({
          text: this.$t('orders.selectedDifferentCustomers'),
          icon: 'warning',
          dangerMode: true,
        })

        return
      }

      this.generateInvoiceData = {
        volume: 0,
        delivery_price: 0,
        local_delivery: 0,
        customer_id: ordersArr[0].customer_id,
        customer_name: ordersArr[0].customer_name,
        warehouse_id: ordersArr[0].warehouse_id,
        transportation_type: ordersArr[0].transportation_type,
        is_ship_only: ordersArr[0].is_ship_only,
        phone: ordersArr[0].phone,
        orders: ordersArr,
      }
      this.orderInvoiceModal = true
    },

    generateInvoiceCustomer(id) {
      const customer = this.customersList.find((x) => x.value === id)

      this.generateInvoiceData = {
        customer_id: customer.value,
        customer_name: customer.text,
        phone: customer.phone,
        orders: [],
      }

      this.orderInvoiceModal = true
    },

    checkDiff(arr) {
      return arr.length !== 0 && new Set(arr).size !== 1
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'updated_at'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'updated_at'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.tableData.warehouse_id_fk = ''
      this.getResults()
    },

    returnToPurchase(id) {
      swal({
        title: this.$t('common.areYouSure'),
        text: this.$t('orders.confirmReturnToPurchasedSection'),
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(this.returnToPurchaseUrl + id + '/return_to_purchase', '', {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(response => {
              this.getResults()
              swal({
                title: this.$t('common.done'),
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    },

    resetGetResults2() {
      this.resetGetResults()
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      this.warehouses = []
      axios.get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id })
          })
        })
    },

    getReasons() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/reason/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data
          this.reasons = result.map(r => ({
            text: r.cancel_reason,
            value: r.cancel_reason,
            ar: r.cancel_reason_ar,
            ku: r.cancel_reason_ku
          }))
        })
    },

    handleWarehouseFilter(val) {
      this.tableData.warehouse_id_fk = Array.isArray(val) && val.length ? val.join(',') : ''
      this.url = 'api/user_delivery_order'
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data
          this.detialData = this.detailResults[0]
        })
      this.modal(modal)
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: this.$t('common.typeToSearch'),
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    },

    handleRefundModal(orderData) {
      this.closeModal('modal_showApp')
      this.openRefundOrderModal(orderData.order_id, orderData.total_amount)
    },

    handlePartialRefundModal(orderData) {
      this.closeModal('modal_showApp')
      this.openPartialRefundOrderModal(orderData.order_id, orderData.total_amount)
    },

    openRefundOrderModal(orderId, totalAmount) {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/order/${orderId}/partial-refunds`, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((res) => {
          this.refundData = {
            partial_refunds: res.data.data.partial_refunds,
            send_sms: false,
            money_amount: totalAmount,
            refund_note: 'full refund',
          }
          this.the_order_id = orderId
          this.theOrderTotalAmount = totalAmount
          this.refundOrderModal = true
        })
    },

    closeRefundOrderModal() {
      this.refundOrderModal = false
      this.checkAlert = false
      this.clearRefund()
    },

    clearRefund() {
      this.refundData = {
        send_sms: false,
      }
      this.theOrderTotalAmount = ''
      this.$validator.reset()
    },

    refundOrder() {
      let token = localStorage.getItem('access_token')
      this.loading = true
      axios
        .put(this.refundOrderUrl + '/' + this.the_order_id, this.refundData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.getResults()
          this.checkAlert = true
          this.loading = false
          this.clearRefund()
          setTimeout(() => {
            this.closeRefundOrderModal()
          }, 1500)
        })
        .catch((error) => {
          if (error.response) {
            swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          }
          this.getResults()
          this.loading = false
        })
    },

    openPartialRefundOrderModal(orderId, totalAmount) {
      let token = localStorage.getItem('access_token')
      axios.get(`api/order/${orderId}/partial-refunds`, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.partialRefundData = {
          order_id_fk: orderId,
          partial_refunds: res.data.data.partial_refunds,
          amount: totalAmount,
          note: this.$t('orders.partialRefundTooltip'),
        }
        this.theOrderTotalAmount = totalAmount
        this.partialRefundOrderModal = true
      })
    },

    closePartialRefundOrderModal() {
      this.partialRefundOrderModal = false
      this.checkAlert = false
      this.partialClear()
    },

    partialClear() {
      this.partialRefundData = {}
      this.theOrderTotalAmount = ''
      this.$validator.reset()
    },

    partialRefundOrder() {
      let token = localStorage.getItem('access_token')
      this.loading = true
      axios
        .post('api/partial-refund', this.partialRefundData, {
          headers: { Authorization: 'Bearer ' + token },
        })
        .then((response) => {
          this.getResults()
          this.checkAlert = true
          this.loading = false
          setTimeout(() => {
            this.partialClear()
            this.closePartialRefundOrderModal()
          }, 1500)
        })
        .catch((error) => {
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
          this.getResults()
          this.loading = false
        })
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td
{
  padding: 0 5px !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.icon-enlarge,
.icon-pencil {
  color: navy;
}

.icon-bin2 {
  color: red;
}

.icon-calendar {
  color: green;
}

.btn {
  transition: all 0.5s;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}
.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 9999;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-color: #484b4e;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/* Mobile order cards: see assets/mobile-order-cards.css */

.customer-name-stack {
  display: inline-flex;
  flex-direction: column;
  vertical-align: middle;
}
.customer-phone-line {
  display: block;
  font-size: 14px;
  color: #666;
}
.combined-cell-td {
  vertical-align: middle;
}
.combined-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  font-size: 15px;
  line-height: 1.4;
  white-space: nowrap;
}
.combined-cell-label {
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/userDeliveredOrder.vue